import React, { ChangeEvent } from "react";
import SettingRow from "../../SettingRow/SettingRow";
import { EBoolean } from "../../../../../shared/types/types";

interface IReviewDateProps {
  value: EBoolean;
  onChange: (event: ChangeEvent<HTMLSelectElement>) => void;
}

const ReviewDate: React.FC<IReviewDateProps> = (props) => {
  return (
    <SettingRow
      label="Ngày đánh giá"
      input={
        <select onChange={props.onChange} value={props.value}>
          <option value={EBoolean.True}>Hiện</option>
          <option value={EBoolean.False}>Ẩn</option>
        </select>
      }
    />
  );
};

export default ReviewDate;
